import { render, staticRenderFns } from "./HMBadge.vue?vue&type=template&id=476386f1&scoped=true&"
import script from "./HMBadge.vue?vue&type=script&lang=js&"
export * from "./HMBadge.vue?vue&type=script&lang=js&"
import style0 from "./HMBadge.vue?vue&type=style&index=0&id=476386f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476386f1",
  null
  
)

export default component.exports